module.exports = __webpack_public_path__ + "Lato-Medium.06e1c8dbe641dd9dfa43.ttf";


//////////////////
// WEBPACK FOOTER
// /Users/davidkross/Project/TaiwaneseTutor/front-end/TaiwaneseTutor/src/assets/fonts/Lato/fonts/Lato-Medium.ttf
// module id = ../../../../../src/assets/fonts/Lato/fonts/Lato-Medium.ttf
// module chunks = styles